<page-header [title]="'app.dashboard.overview-step-guide' | i18n" [action]="phActionTpl">
  <ng-template #phActionTpl></ng-template>
</page-header>
<full-content [fullscreen]="false">
  <nz-card>
    <markdown src="../../../../assets/guid/guid.md" />
  </nz-card>
</full-content>
